import { Voucher } from '../../models/Voucher'
import { aetherApi } from './aetherApi'
import { ReportBuilderRequest, ReportBuilderUrl } from '../../models/ReportBuilder'

export const reportBuilderApi = aetherApi.injectEndpoints({
  endpoints: (builder) => ({
    getReportUrl: builder.query<ReportBuilderUrl, ReportBuilderRequest>({
      query: (request) => (
        {
          url:'api/v1/advance/getAdvanceReportToken',
          method: 'POST',
          body: request,
        }
      ),
      // Disable cache to get a new token even if parameters does not change
      keepUnusedDataFor: 0,
    }),
  }),
})

export const {
  useGetReportUrlQuery,
} = reportBuilderApi
